<template>
    <div class="h-full">
      
      <div :class="route.name == 'NftDetailPage' || route.name =='CollectionPage' ? 'p-0' : 'p-4'" class="custom-bg flex flex-col h-fit min-h-full">
        <router-view></router-view>
      </div>
    </div>
  </template>
  
  <script setup>
  import { RouterView, useRoute } from 'vue-router'

  const route = useRoute()
  </script>
  <style>
  .route-enter-from {
    opacity: 0;
    transform: translateX(100px);
  }
  .route-enter-active,
  .route-leave-active {
    transition: all 0.2s ease-out;
  }
  .route-leave-to {
    opacity: 0;
    transform: translateX(100px);
  }
  </style>